import React from 'react'
import { NotAvailable } from '@myxplor/ui'

const isProd = process.env['NODE_ENV'] === 'production'

const isNullOrUndefined = val => val === null || val === undefined

export const customFn = (record, { label, fn }) => {
  try {
    const result = fn(record)
    return isNullOrUndefined(result) ? <NotAvailable name={label} /> : result
  } catch (error) {
    return (
      <div className="recordDisplay__error" title={error.message}>
        {isProd ? <NotAvailable name={label} /> : error.message}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/record-display/views/custom-fn.js